function getBackEndProjectVo() {
  // 从resource/list接口拿的
  if (typeof window === 'object') {
    if (sessionStorage.getItem('user-sessionStorage')) {
      const { state } = JSON.parse(sessionStorage.getItem('user-sessionStorage'));
      return state?.projectConfigVO;
    }
  }
  return undefined;
}

// 定义不同环境下的静态域名
function getDomains(env) {
  // 硬编码配置
  if (env === 'local') {
    env = 'dev';
  } else if (env === 'dev') {
    env = 'dev-';
  } else if (env === 'pro') {
    env = '';
  }
  const frontEndConfig = {
    lcscWwwUrl: `https://${env}www.szlcsc.com`,
    lcscWwwApiUrl: `https://${env}www-api.szlcsc.com`,
    lcscImageUrl: `https://alimg.szlcsc.com`,
    lcscSearchUrl: `https://${env}so.szlcsc.com`,
    lcscCasUrl: `https://${env === 'fat' ? 'test' : env}passport.szlcsc.com`,
    jlcWebsiteUrl: `https://${env === 'uat' ? 'test' : 'www'}.jlc.com`,
    lcscClubUrl: `http://${env}club.szlcsc.com`,
    lcscOverseaUrl: `https://${env}overseas.szlcsc.com`,
    lcscSaleUrl: `https://${env}activity.szlcsc.com`,
    lcscCartUrl: `https://${env}cart.szlcsc.com`,
    lcscCartApiUrl: `https://${env}cart-api.szlcsc.com`,
    lcscMemberUrl: `https://${env}member.szlcsc.com`,
    lcscBomUrl: `https://${env}bom.szlcsc.com`,
    lcscSotipUrl: `https://${env}tip.szlcsc.com`,
    lcscListUrl: `https://${env}list.szlcsc.com`,
    lcscItemUrl: `https://${env === 'fat' ? 'fat-item-next' : 'item'}.szlcsc.com`,
    lcscOpUrl: `https://${env}op.szlcsc.com`,
    lcscPayUrl: `https://${env}pay.szlcsc.com`,
    lcscOrderUrl: `https://${env}order.szlcsc.com`,
    lcscOrderApiUrl: `https://${env}order-api.szlcsc.com`,
    lcscActivityUrl: `https://${env}activity.szlcsc.com`,
    lcscConsignUrl: `https://${env}consign.szlcsc.com`,
    lcscQqUrl: `http://qq.szlcsc.com`,
    lcscStaticUrl: `https://static.szlcsc.com`,
    lcscAttaUrl: `https://atta.szlcsc.com`,
    lcscCollectorUrl: `https://${env}collector.szlcsc.com`,
    lcscCustomerUrl: `https://${env}club.szlcsc.com`,
    jlcCasUrl: `https://${env + (env === 'pro' ? '' : '-')}passport.jlc.com`,
    lcscDosUrl: `https://${env}dos.szlcsc.com`,
    lcscDosApiUrl: `https://${env}dos-api.szlcsc.com`,
    lcscMroUrl: `https://${env}mro.szlcsc.com`,
    coolicUrl: `https://${env}www.coolic.com`,
    lcscMbUrl: `https://${env}www.szlcmb.com`,
  };

  // 还是优先取后端的配置吧,取不到再用静态的
  const backEndConfig = getBackEndProjectVo();
  if (backEndConfig && Object.keys(backEndConfig).length !== 0) {
    return Object.assign(frontEndConfig, backEndConfig);
  } else {
    return frontEndConfig;
  }
}

// 获取当前环境
const currentEnvironment = typeof window === 'object' ? process.env.NEXT_PUBLIC_APP_ENV : process.env.APP_ENV;

// 导出静态域名
export default getDomains(currentEnvironment);
